import {Metafield} from '@shopify/hydrogen/storefront-api-types';

export default function normalizeAdditionalFields(
  additionalFields?: Metafield,
) {
  if (additionalFields?.value == null) return null;
  try {
    const val = JSON.parse(additionalFields.value);
    return val;
  } catch (error) {
    console.error(error);
    return null;
  }
}
